import TreadingLocationSlide from "./TreadingLocationSlide";
import { TreadingLocationSlideProps } from "./ITreadingLocationSlide";

export type { TreadingLocationSlideProps };
export default TreadingLocationSlide;
